module.exports = __webpack_public_path__ + "img/Logo Nakdan_Blue_Circle.f56bde4e.png";